import SectionHub from '@/components/docs/SectionHub';

export default function Docs01MarketDataForexHub() {
  return <SectionHub sectionPath="01-market-data/forex" />;
}
